import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgN600HeatMap = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 500 500",
	style: { enableBackground: "new 0 0 500 500" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M250.01,397.8c-0.52,0-1.04,0-1.56-0.01c-30.37-0.4-58.84-12.71-80.18-34.65 c-21.36-21.96-32.87-50.81-32.42-81.21c0.54-36.71,18.9-71.14,49.11-92.1l22.36-15.52l-9.27,25.59 c-3.93,10.77-9.23,34.74-1.3,48.77c3.56,6.29,9.51,10.16,18.21,11.85c9.84,1.91,13.46-1.9,14.65-3.14 c5.69-5.97,6.52-18.68,4.93-25.17c-4.75-19.34-8.83-36.57-10.63-51.56c-3.54-29.32,2.14-48.99,19.6-67.9l9.73-10.53l4.8,13.51 c5.83,16.42,14.74,31.94,26.46,46.14c8.99,10.9,19.37,19.66,32.17,29.47c15.55,11.92,26.39,24.19,34.09,38.62 c8.77,16.41,13.4,34.99,13.4,53.71c0,30.78-12.07,59.64-33.97,81.26C308.65,386.15,280.23,397.8,250.01,397.8z M175.71,221.57 c-14.06,16.86-22.2,38.24-22.53,60.61c-0.38,25.77,9.39,50.24,27.52,68.88c18.11,18.62,42.25,29.07,67.99,29.41 c26.16,0.35,50.75-9.56,69.33-27.9c18.58-18.34,28.82-42.82,28.82-68.93c0-15.89-3.93-31.63-11.36-45.54 c-6.5-12.17-15.83-22.67-29.35-33.03c-11.89-9.11-24.36-19.32-34.99-32.2c-9.56-11.58-17.44-23.99-23.54-37.02 c-6.93,11.65-8.69,24.46-6.49,42.71c1.69,14.03,5.65,30.72,10.26,49.5c2.38,9.71,1.99,29.49-9.21,41.25 c-5.18,5.44-14.67,11.28-30.5,8.21c-13.78-2.67-23.87-9.51-29.99-20.33C175.52,246.31,174.67,233.11,175.71,221.57z"
	}) })]
});
const ForwardRef = forwardRef(SvgN600HeatMap);
export { ForwardRef as ReactComponent };
